import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfStay from "@/pages/TermsOfStay";
import CancellationPolicy from "@/pages/CancellationPolicy";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-stay" element={<TermsOfStay />} />
          <Route path="/cancellation-policy" element={<CancellationPolicy />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
        <Toaster
          position="top-center"
          toastOptions={{
            style: { background: "#2C392F", color: "#F7F5F0", border: "none", fontFamily: "Manrope" },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
